const StringHelper = {
	getFirstName(fullName: string) {
		return fullName.split(" ")[0];
	},
	slugify(text: string) {
		return text
			.toString()
			.normalize("NFKD")
			.toLowerCase()
			.trim()
			.replace(/\s+/g, "-")
			.replace(/[^\w\\-]+/g, "")
			.replace(/\\-\\-+/g, "-");
	},
	isValidUUID(value: string) {
		const regexExp =
			/^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;
		return regexExp.test(value);
	},
	formattedPhoneNumber(phone: string) {
		if (phone.length === 10) {
			return `(${phone.slice(0, 2)}) ${phone.slice(2, 6)}-${phone.slice(6)}`;
		}
		return `(${phone.slice(0, 2)}) ${phone.slice(2, 7)}-${phone.slice(7)}`;
	},
	formattedPhoneNumber0800(phone: string) {
		return `${phone.slice(0, 4)} ${phone.slice(4, 7)} ${phone.slice(7)}`;
	},
	isValidHttpUrl(url: string) {
		try {
			const newUrl = new URL(url);
			return newUrl.protocol === "http:" || newUrl.protocol === "https:";
		} catch (err) {
			return false;
		}
	}
};

export default StringHelper;
